export function MessageChatCircleIcon() {
  return (
    <svg
      fill="none"
      height="12"
      viewBox="0 0 12 12"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2763_6776)">
        <path
          d="M3.04718 5.6144C3.0161 5.41411 2.99998 5.20893 2.99998 5C2.99998 2.79086 4.80262 1 7.0263 1C9.24997 1 11.0526 2.79086 11.0526 5C11.0526 5.49904 10.9606 5.97673 10.7926 6.41725C10.7577 6.50874 10.7402 6.55449 10.7323 6.59021C10.7244 6.62559 10.7214 6.65049 10.7206 6.68673C10.7197 6.7233 10.7247 6.76359 10.7346 6.84416L10.9359 8.47926C10.9577 8.65627 10.9686 8.74477 10.9391 8.80911C10.9133 8.86548 10.8675 8.91026 10.8105 8.93475C10.7455 8.9627 10.6573 8.94977 10.4809 8.92391L8.88823 8.69046C8.80507 8.67827 8.76349 8.67217 8.72562 8.67239C8.68816 8.6726 8.66224 8.67537 8.62557 8.68307C8.58852 8.69086 8.54117 8.7086 8.44649 8.74406C8.00484 8.90949 7.52621 9 7.0263 9C6.8172 9 6.61183 8.98417 6.41133 8.95364M3.81579 11C5.29824 11 6.5 9.76878 6.5 8.25C6.5 6.73122 5.29824 5.5 3.81579 5.5C2.33334 5.5 1.13158 6.73122 1.13158 8.25C1.13158 8.5553 1.18014 8.84897 1.26977 9.12336C1.30767 9.23935 1.32661 9.29735 1.33283 9.33697C1.33932 9.37833 1.34046 9.40156 1.33804 9.44336C1.33572 9.4834 1.32571 9.52865 1.30567 9.61915L1 11L2.4974 10.7955C2.57913 10.7843 2.62 10.7788 2.65568 10.779C2.69326 10.7793 2.7132 10.7813 2.75005 10.7886C2.78505 10.7956 2.83708 10.814 2.94114 10.8507C3.2153 10.9475 3.50955 11 3.81579 11Z"
          stroke="#079455"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2763_6776">
          <rect fill="white" height="12" width="12" />
        </clipPath>
      </defs>
    </svg>
  );
}
